import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { formatDatePP } from '../../components/SellerProfile/Form/formHelpers';
//simport OnboardingCompleteModal from '../../components/SellerProfile/OnboardingCompleteModal/OnboardingCompleteModal';

export interface SellerProfileState {
  onboardingStatus: any;
  apiStatus: string;
  seller_id?: string;
  users: any[];
  user_id?: string;
  compProfile: Record<string, any[]>;
  error: string | null;
  isLoading: boolean;
  defaultCompData: Record<string, any>;
  company_name: string;
  isAdmin: boolean;
  updating: boolean;
  compSubmitting: boolean;
  loading?: boolean;
  success: boolean;
  addSuccess: boolean;
  modalDataLoaded2: boolean;
  removingUser: boolean;
  saveUpdates: boolean;
  submitSuccess: boolean;
  removeSuccess: boolean;
  isAddingUser: boolean;
  formLoading: boolean;
  user_approved:boolean;
  showSuccessPopUp:string;
  successType: string;
  errorMsg:string;
  spPageText:string;
  onboardCompletePopupDetails:any;
  modalType:string;
  filterUsers:string;
  showingUsers:string;
  disabledBttn:any;
  formUpdates:any;
  addinguserError:boolean;
  dispError:string;
}

// interface FetchCompanyProfilePayload {
//   seller_id: string;
//   language: 'fr'|'en';
// }

const initialState: SellerProfileState = {
  onboardingStatus: {},
  apiStatus: 'Loading...',
  seller_id: '',
  users: [],
  user_id: '',
  compProfile: {},
  defaultCompData: {},
  error: null,
  isLoading: false,
  company_name: '',
  isAdmin: false,
  updating: false,
  compSubmitting: false,
  loading: false,
  success: false,
  addSuccess: false,
  modalDataLoaded2: false,
  removingUser: false,
  saveUpdates: false,
  submitSuccess: false,
  removeSuccess: false,
  isAddingUser: false,
  formLoading: false,
  user_approved: false,
  showSuccessPopUp: '',
  successType: '',
  errorMsg: '',
  spPageText: '',
  onboardCompletePopupDetails: {
    show: false,
    navigate: false,
    close: false
  },
  modalType:'',
  filterUsers:'',
  showingUsers:'true',
  formUpdates:{},
  disabledBttn:{},
  addinguserError:false,
  dispError:'',
};

const sellerProfileSlice = createSlice({
  name: 'sellerProfile',
  initialState,
  reducers: {
    getUserIdAndSellerId(state) {},
    setSeller_id(state, action: PayloadAction<string>) {
      state.seller_id = action.payload;
    },
    setUser_id(state, action: PayloadAction<string>) {
      state.user_id = action.payload;
    },
    getStatus(state, action: PayloadAction<{ seller_id: string }>) {},
    setOnboardingStatus: (state, action: PayloadAction<any>) => {
      state.onboardingStatus = action.payload;
    },
    setApiStatus: (state, action: PayloadAction<string>) => {
      state.apiStatus = action.payload;
    },
    setUsers: (state, action: PayloadAction<any[]>) => {
      state.users = action.payload;
    },
    setIndUserData: (state, action: PayloadAction<any[]>) => {
      state.users = action.payload;
    },
    fecthAllUsers(
      state,
      action: PayloadAction<{ seller_id: string; user_id: string }>
    ) {
      state.seller_id = action.payload.seller_id;
      state.user_id = action.payload.user_id;
    },
    fetchCompanyProfileStart(state, action: PayloadAction<any>) {
      state.isLoading = true;
      state.error = null;
    },
    fetchCompanyProfileSuccess(state, action: PayloadAction<any>) {
      state.isLoading = false;
      const { finalSellerData, finalContactData, defaultCoData, language, enCodeMap = {}, frCodeMap = {} } =
        action.payload;
      // ── POS: parse comma-separated codes from pos_code ──────────────────────
      const posCodes = (finalSellerData?.pos_code || '').split(',').map((c: string) => c.trim()).filter(Boolean);
      const pos_typeArr: string[] = posCodes.map((code: string) => {
        const found = defaultCoData?.pos_type?.find((pos: any) => pos.pos_code === code);
        if (!found) return code;
        return language === 'fr'
          ? `${found.pays || found.country} ${found.pos_code}`
          : `${found.country} ${found.pos_code}`;
      });
      const otherPOSArr: string[] = [];

      // ── Contact: embedded in seller data ─────────────────────────────────
      const contactFields = [
        'contact_first_name',
        'contact_last_name',
        'contact_phone',
        'contact_email',
        'contact_type',
        'contact_id'
      ];
      const adminContact = finalContactData.filter(
        (contact: any) =>
          contact['contact_type'] && contact['contact_type'] === 'admin'
      );
      contactFields.forEach((field) => {
        finalSellerData[`admin_${field}`] = adminContact.length
          ? adminContact[0][field]
          : '';
      });

      // ── Business model: look up label from code ───────────────────────────
      const bmCodes = (finalSellerData?.business_model || '').split(',').map((c: string) => c.trim()).filter(Boolean);
      const business_model_type = bmCodes.map((code: string) => {
        const found = defaultCoData?.business_model?.find((bm: any) => bm.business_model_id === code);
        if (!found) return code;
        return language === 'fr'
          ? (found.business_model_type_fr || found.business_model_type || code).trim()
          : (found.business_model_type || code).trim();
      }).filter(Boolean);

      // ── Customer type: look up label from code ────────────────────────────
      const ctFound = defaultCoData?.customer_types?.find((ct: any) => ct.customer_type_id === finalSellerData?.customer_type_id);
      const customer_type = language === 'fr'
        ? (ctFound?.customer_type_fr || finalSellerData?.customer_type_id || '')
        : (ctFound?.customer_type || finalSellerData?.customer_type_id || '');

      // ── Status: map code to EN/FR display labels ──────────────────────────
      const statusCode = finalSellerData?.status_type || '';
      // Fall back to pre-translated labels from old API if status code not mapped
      const status_en = enCodeMap[statusCode] || finalSellerData?.status_en || statusCode;
      const status_fr = frCodeMap[statusCode] || finalSellerData?.status_fr || statusCode;

      state.compProfile = {
        ...finalSellerData,
        customer_type_id: customer_type.toLowerCase(),
        customer_type,
        business_model_id: business_model_type,
        business_model_type,
        api_schema_version:
          finalSellerData?.api_schema_version?.split(',') || [],
        pos_type: pos_typeArr,
        otherPOS: otherPOSArr,
        implementation_start_date: formatDatePP(finalSellerData?.implementation_start_date),
        iata_number: finalSellerData.iata_number || '',
        // field aliases for renamed API fields
        booking_volume: finalSellerData.booking_volumes,
        sales_domestic: finalSellerData.sales_mix_domestic,
        sales_cross_border: finalSellerData.sales_mix_transborder,
        sales_international: finalSellerData.sales_mix_international,
        support_flow: finalSellerData.supported_flow,
        status_en,
        status_fr,
        status_type: statusCode,
        pos_iata_map: finalSellerData?.pos_iata_map || {},
      };

      if (state.defaultCompData?.pos_type) {
        state.defaultCompData.pos_type.sort((a: any, b: any) => {
          const countryA = language === 'fr' ? a.pays || a.country : a.country;
          const countryB = language === 'fr' ? b.pays || b.country : b.country;
          return countryA.localeCompare(countryB);
        });
      }
      // state.defaultCompData = defaultCoData;
    },
    fetchCompanyProfileFailure(state, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = action.payload;
    },
    setDefaultCompData(state, action: PayloadAction<any>) {
      state.defaultCompData = action.payload;
    },
    setCompanyName(state, action: PayloadAction<string>) {
      state.company_name = action.payload;
    },
    updateCompanyProfileStart(state, action: PayloadAction<any>) {
      state.updating = true;
      state.compSubmitting = false;
      state.error = null;
    },
    updateCompanyProfileSuccess(state, action: PayloadAction<any>) {
      state.updating = false;
      state.compSubmitting = false;
    },
    updateCompanyProfileFailure(state, action: PayloadAction<any>) {
      state.updating = false;
      state.compSubmitting = false;
      state.error = action.payload;
    },
    setCompanySubmitt(state, action: PayloadAction<boolean>) {
      state.compSubmitting = action.payload;
    },
    setIsAdmin(state, action: PayloadAction<boolean>) {
      state.isAdmin = action.payload;
    },
    setAddUsers(state, action: PayloadAction<any>) {
      state.success = false;
      state.isLoading = true;
      state.error = null;
      state.addSuccess = false;
      state.addinguserError = false;
    },
    setAddUsersSuccess(state, action: PayloadAction<any>) {
      state.success = true;
      state.isLoading = false;
      state.error = null;
      state.addSuccess = true;
      state.user_approved = { ...action.payload };
      state.addinguserError = false;
    },
    setAddUsersFailure(state, action: PayloadAction<string>) {
      state.success = false;
      state.isLoading = false;
      state.error = action.payload;
      state.addSuccess = false;
      state.addinguserError = true;      
    },
    setDispError(state, action: PayloadAction<any>){
      state.dispError = action.payload;      
    },
    resetSuccess(state, action: PayloadAction<any>) {
      state.addSuccess = action.payload;
      state.success = action.payload;
      state.isLoading = action.payload
    },
    setaddingUserError(state, action: PayloadAction<any>) {
      state.addinguserError = action.payload;
    },
    fetchgetIndUser(state, action: PayloadAction<{ curr_user_id: string }>) {
      state.modalDataLoaded2 = false;
    },
    fetchgetIndUserSuccess(state, action: PayloadAction<any>) {
      const updatedUsers = state.users.map((user) => {
        return user.user_id === action.payload.user_id
          ? { ...user, ...action.payload }
          : user;
      });
      state.users = updatedUsers;
      state.modalDataLoaded2 = true;
    },
    fetchgetIndUserFailure(state, action: PayloadAction<string>) {
      state.error = action.payload;
      state.modalDataLoaded2 = false;
    },
    deleteUserStart(state, action: PayloadAction<{ curr_user_id: string }>) {
      state.removingUser = true;
      state.removeSuccess = false;
    },
    deleteUserSuccess(state, action: PayloadAction<any>) {
      state.removingUser = false;
      state.removeSuccess = true;
    },
    deleteUserFailure(state, action: PayloadAction<any>) {
      state.error = action.payload;
      state.removingUser = false;
      state.removeSuccess = false;
    },
    resetRemovingSuccess(state, action: PayloadAction<any>) {
      state.removeSuccess = action.payload;
    },
    updateUserStart(state, action: PayloadAction<any>) {
      state.saveUpdates = true;
      state.submitSuccess = false;
      state.error = null;
    },
    updateUserSuccess(state, action: PayloadAction<any>) {
      state.saveUpdates = false;
      state.submitSuccess = true;
      state.error = null;
    },
    updateUserFailure(state, action: PayloadAction<any>) {
      state.saveUpdates = false;
      state.submitSuccess = false;
      state.error = action.payload;
    },
    resetSubmitSuccess(state, action: PayloadAction<any>) {
      state.submitSuccess = action.payload;
    },
    setIsAddingUser(state, action: PayloadAction<any>) {
      state.isAddingUser = action.payload;
    },
    setFormLoading(state, action: PayloadAction<any>) {
      state.formLoading = action.payload;
    },
    setShowSuccessPopUp(
      state,
      action: PayloadAction<
        string | { message: string; successType?: 'success' | 'error' }
      >
    ) {
      if (typeof action.payload === 'string') {
        state.showSuccessPopUp = action.payload;
        state.successType = 'success';
      } else {
        state.showSuccessPopUp = action.payload.message;
        state.successType = action.payload.successType || 'success';
      }
    },
    setErrorMsg(state, action: PayloadAction<string>) {
      state.errorMsg = action.payload;
    },
    setSpPageText(state, action: PayloadAction<string>) {
      state.spPageText = action.payload;
    },
    setOnboardCompletePopupDetails(state, action) {
      state.onboardCompletePopupDetails = action.payload;
    },
    setModalType(state, action: PayloadAction<string>) {
      state.modalType = action.payload;
    },
    setFilterUsers(state, action: PayloadAction<string>) {
      state.filterUsers = action.payload;
    },
    setShowingUsers(state, action: PayloadAction<string>) {
      state.showingUsers = action.payload;
    },
    setFormUpdates(state, action: PayloadAction<any>) {
      const updates = { ...action.payload };
      //   if (
      //   updates.editCompanyProfile &&
      //   updates.editCompanyProfile.impDetailsGroup &&
      //   updates.editCompanyProfile.impDetailsGroup.options &&
      //   updates.editCompanyProfile.impDetailsGroup.options.sellerPOSinfo &&
      //   updates.editCompanyProfile.impDetailsGroup.options.sellerPOSinfo.options &&
      //   updates.editCompanyProfile.impDetailsGroup.options.sellerPOSinfo.options.pos_type &&
      //   Array.isArray(updates.editCompanyProfile.impDetailsGroup.options.sellerPOSinfo.options.pos_type.content)
      // ) {
      //   updates.editCompanyProfile.impDetailsGroup.options.sellerPOSinfo.options.pos_type.content =
      //     updates.editCompanyProfile.impDetailsGroup.options.sellerPOSinfo.options.pos_type.content.map(
      //       (item: string) => (typeof item === 'string' ? item.split(' ')[0] : item)
      //     );
      // }

      state.formUpdates = updates;
    },
    setDisabledBttn(state, action: PayloadAction<any>) {
      state.disabledBttn = action.payload;
    }
  }
});

export const {
  getUserIdAndSellerId,
  setSeller_id,
  setUser_id,
  setOnboardingStatus,
  setApiStatus,
  getStatus,
  setUsers,
  fecthAllUsers,
  fetchCompanyProfileFailure,
  fetchCompanyProfileStart,
  fetchCompanyProfileSuccess,
  setDefaultCompData,
  setCompanyName,
  setIsAdmin,
  updateCompanyProfileFailure,
  updateCompanyProfileStart,
  updateCompanyProfileSuccess,
  setCompanySubmitt,
  setIndUserData,
  setAddUsers,
  setAddUsersSuccess,
  setAddUsersFailure,
  resetSuccess,
  setaddingUserError,
  fetchgetIndUser,
  fetchgetIndUserSuccess,
  fetchgetIndUserFailure,
  deleteUserFailure,
  deleteUserStart,
  deleteUserSuccess,
  resetRemovingSuccess,
  updateUserFailure,
  updateUserStart,
  updateUserSuccess,
  resetSubmitSuccess,
  setIsAddingUser,
  setFormLoading,
  setShowSuccessPopUp,
  setErrorMsg,
  setSpPageText,
  setOnboardCompletePopupDetails,
  setModalType,
  setFilterUsers,
  setShowingUsers,
  setFormUpdates,
  setDisabledBttn,
  setDispError

} = sellerProfileSlice.actions;

export default sellerProfileSlice.reducer;
